import type { ISimpleSelectItem } from '../../components/select/SimpleSelect';

export const CLAIM_STATUS_DEFINITIONS = [
  { key: 'Open', label: 'Open' },
  { key: 'InProgress', label: 'In behandeling' },
  { key: 'Resolved', label: 'Opgelost' },
  { key: 'Closed', label: 'Afgesloten' },
] as const;

export const CLAIM_STATUS_OPTIONS: ISimpleSelectItem[] = CLAIM_STATUS_DEFINITIONS.map((s) => ({
  key: s.key,
  name: s.label,
}));

export const CLAIM_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  CLAIM_STATUS_DEFINITIONS.map((s) => [s.key, s.label]),
);

export function validateClaimForm(values: { counterParty: string; amount: string }): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!values.counterParty) {
    errors.counterParty = 'Tegenpartij is verplicht';
  }
  const numericAmount = parseFloat(values.amount);
  if (!values.amount || Number.isNaN(numericAmount) || numericAmount <= 0) {
    errors.amount = 'Bedrag moet groter zijn dan 0';
  }
  return errors;
}
